export const emailRegex =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
export const zipRegex = /^[0-9]{5}(?:-[0-9]{4})?$/i
export const rateRegex = /^(\d+(\.\d{0,3})?|\.\d{0,3})%?$/
